// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ant-dropdown-menu-item:has(.src-components-buttons-DropdownChildButton-DropdownChildButton-module__button--qND9f) {
  padding: 0 !important;
  background: none !important;
}
.ant-dropdown-menu-item:has(.src-components-buttons-DropdownChildButton-DropdownChildButton-module__button--qND9f) .src-components-buttons-DropdownChildButton-DropdownChildButton-module__button--qND9f {
  border: none;
  background-color: transparent;
  box-shadow: none;
  display: flex;
  align-items: center;
  padding: 5px 12px;
  width: 100%;
  font-size: inherit;
  height: auto;
  color: inherit;
}
.ant-dropdown-menu-item:has(.src-components-buttons-DropdownChildButton-DropdownChildButton-module__button--qND9f) .src-components-buttons-DropdownChildButton-DropdownChildButton-module__button--qND9f:disabled {
  color: #0000004d !important;
}
.ant-dropdown-menu-item:has(.src-components-buttons-DropdownChildButton-DropdownChildButton-module__button--qND9f) .src-components-buttons-DropdownChildButton-DropdownChildButton-module__button--qND9f:hover:not(:disabled) {
  background-color: rgba(0, 0, 0, 0.04);
  color: inherit !important;
}
`, "",{"version":3,"sources":["webpack://./src/components/buttons/DropdownChildButton/DropdownChildButton.module.less"],"names":[],"mappings":"AAAA;EACE,qBAAA;EACA,2BAAA;AACF;AAHA;EAKI,YAAA;EACA,6BAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,iBAAA;EACA,WAAA;EACA,kBAAA;EACA,YAAA;EACA,cAAA;AACJ;AAfA;EAkBI,2BAAA;AAAJ;AAlBA;EAsBI,qCAAA;EACA,yBAAA;AADJ","sourcesContent":[":global(.ant-dropdown-menu-item):has(.button) {\n  padding: 0 !important;\n  background: none !important;\n\n  .button {\n    border: none;\n    background-color: transparent;\n    box-shadow: none;\n    display: flex;\n    align-items: center;\n    padding: 5px 12px;\n    width: 100%;\n    font-size: inherit;\n    height: auto;\n    color: inherit;\n  }\n\n  .button:disabled {\n    color: #0000004d !important;\n  }\n\n  .button:hover:not(:disabled) {\n    background-color: rgba(0, 0, 0, 0.04);\n    color: inherit !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"button": `src-components-buttons-DropdownChildButton-DropdownChildButton-module__button--qND9f`
};
export default ___CSS_LOADER_EXPORT___;
